export default __webpack_public_path__ + "static/media/3669_124699.7253d21c.svg";